import Type from "@/model/types/Type";

const type = {
    ONLY_FIRST_PHOTO: 10, /*Padrão*/
    BEFORE_AFTER: 20,
    FIRST_9_PHOTOS: 90,
    FIRST_ALL_PHOTOS: 100,
}

const list = [
    {
        value: type.ONLY_FIRST_PHOTO,
        title: 'Somente Foto principal',
        text: 'Somente Foto principal',
        description: 'Destaca a principal evidência de cada apontamento.',
        badge: 'Mais usado',
        preview: 'https://static.onlaine.com.br/svgs/report_layout/report_layout_10.svg',

    },
    {
        value: type.BEFORE_AFTER,
        title: 'Fotos do Antes e Depois',
        text: 'Fotos do Antes e Depois',
        description: 'Ideal para demonstrar evolução e correções.',
        badge: 'Executivo',
        preview: 'https://static.onlaine.com.br/svgs/report_layout/report_layout_20.svg',
    },
    {
        value: type.FIRST_9_PHOTOS,
        title: 'Até 9 primeiras fotos',
        text: 'Até 9 primeiras fotos',
        description: 'Resumo fotográfico compacto com múltiplas evidências.',
        badge: 'Compacto',
        preview: 'https://static.onlaine.com.br/svgs/report_layout/report_layout_90.svg',
    },
    {
        value: type.FIRST_ALL_PHOTOS,
        title: 'Todas as fotos grandes',
        text: 'Todas as fotos grandes',
        description: 'Relatório detalhado com todas as imagens em destaque.',
        badge: 'Detalhado',
        preview: 'https://static.onlaine.com.br/svgs/report_layout/report_layout_100.svg',
    }

]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}